import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

// Servicio que abstrae el acceso a localStorage y sessionStorage.
// Antes de tocar el storage verifica que estemos en un navegador,
// lo que evita errores durante el server-side rendering.
@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private platformId = inject(PLATFORM_ID);
  private isBrowser: boolean;

  constructor() {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  // Guarda un valor en localStorage (o sessionStorage si session es true).
  // El valor se serializa a JSON para poder almacenar objetos y arrays.
  saveStorageData(itemName: string, data: any, session?: boolean): void {
    if (!this.isBrowser) return;

    if (session) {
      sessionStorage.setItem(itemName, JSON.stringify(data));
    } else {
      localStorage.setItem(itemName, JSON.stringify(data));
    }
  }

  // Recupera un valor almacenado. Busca primero en localStorage y si no
  // lo encuentra busca en sessionStorage. Devuelve undefined si no existe.
  loadStorageData(itemName: string): any {
    if (!this.isBrowser) return undefined;

    let data = undefined;

    if (localStorage.getItem(itemName)) {
      const stringData = localStorage.getItem(itemName) || '';
      data = JSON.parse(stringData);
    } else if (sessionStorage.getItem(itemName)) {
      const stringData = sessionStorage.getItem(itemName) || '';
      data = JSON.parse(stringData);
    }

    return data;
  }

  // Elimina un item de ambos storages por si acaso estaba en los dos
  removeStorageData(itemName: string): void {
    if (!this.isBrowser) return;

    if (localStorage.getItem(itemName)) {
      localStorage.removeItem(itemName);
    }
    if (sessionStorage.getItem(itemName)) {
      sessionStorage.removeItem(itemName);
    }
  }
}
